import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import { Row, Col, Button, Table } from "react-bootstrap";
import {
  fetchTimesheets,
  resetTimesheet,
  PENDING,
  SET_TIMESHEET_PAGINATION,
} from "../../store/actions/timesheet/timesheetActions";
import { getWeeksInYear } from "../../store/actions/commonActions";
import ListPagination from "../../common/ListPagination";

import moment from "moment";

import PageTitle from "../../common/PageTitle";

class Timesheet extends Component {
  componentDidMount() {
    this.props.fetchTimesheets();
    this.props.getWeeksInYear();
  }

  renderTimesheets = () => {
    let timesheets = this.props.timesheets.timesheets;
    console.log(this.props.timesheets.timesheets);

    let timesheetList = "";

    if (timesheets) {
      //if the user tries to search and no matches the filter
      if (!timesheets.length) {
        timesheets = null;
      } else {
        let min = this.props.timesheets.min;
        let max = this.props.timesheets.max;

        //don't paginate if there's filter
        if (this.props.timesheets.timesheets) {
          timesheets = timesheets.slice(min - 1, max);
        }
      }
    }

    if (timesheets) {
      timesheetList = timesheets.length ? (
        timesheets.map((timesheet, key) => {
          const start_date = timesheet.start_date || new Date();

          let requestID =
            "TSR" +
            moment(start_date).format("YYYYMM") +
            timesheet.timesheet_id.toString().padStart(6, "0");
          let statusBlurb = timesheet.status;

          //get pending approver
          if (timesheet.status === PENDING && timesheet.approvers.length) {
            let approversList = [];

            for (
              let currentSequence = 0;
              currentSequence < 50;
              currentSequence++
            ) {
              approversList = timesheet.approvers
                .filter(
                  (approver) =>
                    approver.status === PENDING &&
                    approver.sequence === currentSequence
                )
                .map(
                  (approver) => approver.last_name + ", " + approver.first_name
                );
              if (approversList.length) {
                break;
              }
            }

            if (approversList.length) {
              const approvers = approversList.map((approver) => (
                <>
                  <br />
                  {approver}
                </>
              ));
              statusBlurb = (
                <div>
                  {timesheet.status} from
                  {approvers}
                </div>
              );
            }
          }

          return (
            <tr key={key}>
              <td className="align-center">
                <Link
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    this.props.resetTimesheet();
                    this.props.history.push(
                      "/timesheet/update?id=" + timesheet.timesheet_id
                    );
                  }}
                >
                  {requestID}
                </Link>
              </td>
              <td className="align-center">{timesheet.start_date}</td>
              <td className="align-center">{timesheet.end_date}</td>
              <td className="align-center">{statusBlurb}</td>
            </tr>
          );
        })
      ) : (
        <tr>
          <td colSpan={4}>
            <i>Loading...</i>
          </td>
        </tr>
      );
    } else {
      timesheetList = (
        <tr>
          <td colSpan={4}>
            <p className="text-danger">No timesheet found.</p>
          </td>
        </tr>
      );
    }

    return (
      <Table hover>
        <thead className="align-center">
          <tr>
            <th>Request ID</th>
            <th>Start Date</th>
            <th>End Date</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>{timesheetList}</tbody>
      </Table>
    );
  };

  render() {
    const currentDate = moment().format("YYYY-MM-DD");
    let timesheets = this.props.timesheets.timesheets;

    const listPagination = timesheets ? (
      <ListPagination
        dispatchType={SET_TIMESHEET_PAGINATION}
        data={this.props.timesheets.timesheets}
        min={this.props.timesheets.min}
        max={this.props.timesheets.max}
        currentPage={this.props.timesheets.currentPage}
        totalPages={this.props.timesheets.totalPages}
        fetchCallback=""
        numItems={this.props.timesheets.numItems}
      />
    ) : (
      ""
    );

    const addTimesheetBtn = (
      <Button
        size="sm"
        onClick={() => {
          this.props.resetTimesheet();
          this.props.history.push("/timesheet/add");
        }}
      >
        Add Timesheet
      </Button>
    );

    if (timesheets) {
      timesheets.map((dailyTask, key) => {
        console.log(dailyTask.date === currentDate);
        if (dailyTask.date === currentDate) {
          this.state.isCurrentDate = true;
        }
      });
    }

    return (
      <React.Fragment>
        <PageTitle pageName="Timesheets" actionButton={addTimesheetBtn} />
        <Row>
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className="float-right mt-3">{listPagination}</div>
          </Col>
        </Row>
        <Row>
          <Col>{this.renderTimesheets()}</Col>
        </Row>
        <Row>
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className="float-right mt-3">{listPagination}</div>
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  timesheets: state.timesheets,
});

const mapDispatchToProps = (dispatch) => {
  return {
    fetchTimesheets: () => dispatch(fetchTimesheets()),
    getWeeksInYear: () => dispatch(getWeeksInYear()),
    resetTimesheet: () => dispatch(resetTimesheet()),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Timesheet)
);
